<template>
  <b-tabs
    v-if="monthlyPaidProduct && annualPaidProduct"
    pills
    class="justify-content-center cadence-tabs mt-3 mb-2 nav-fill"
  >
    <b-tab
      :active="activeTab === annualPaidProduct.productId"
      @click="$emit('setSelectedProduct', annualPaidProduct)"
      data-test-hook="subscription-cadence-tabs-annual"
    >
      <template #title>
        <i v-if="activeTab === annualPaidProduct.productId" class="fa-solid fa-check mr-1" />
        {{ $t('xBilledAnnually') }}
      </template>
    </b-tab>
    <b-tab
      :active="activeTab === monthlyPaidProduct.productId"
      @click="$emit('setSelectedProduct', monthlyPaidProduct)"
      data-test-hook="subscription-cadence-tabs-monthly"
    >
      <template #title>
        <i v-if="activeTab === monthlyPaidProduct.productId" class="fa-solid fa-check mr-1" />
        {{ $t('xBilledMonthly') }}
      </template>
    </b-tab>
  </b-tabs>
</template>

<script>
export default {
  props: ['monthlyPaidProduct', 'annualPaidProduct', 'selectedProduct'],
  emits: ['setSelectedProduct'],
  data() {
    return {
      activeTab: null
    }
  },
  mounted() {
    if (this.selectedProduct?.productId) {
      this.activeTab = this.selectedProduct.productId
    }
  },
  watch: {
    selectedProduct: function(newVal) {
      if (newVal?.productId) {
        this.activeTab = newVal.productId
      }
    }
  }
}
</script>
<style lang="scss">
.cadence-tabs {
  .nav-pills {
    justify-content: center;
  }
  .nav-link {
    border: solid 2px var(--blue-700) !important;
    color: var(--carbon-900);
    height: 44px;
    justify-content: center;
    align-items: center;
    display: flex;
  }
  .nav-item:first-of-type .nav-link {
    border-radius: 9999px 0 0 9999px;
  }

  .nav-item:last-of-type .nav-link {
    border-radius: 0 9999px 9999px 0;
  }

  i {
    display: none !important;
  }

  .active i {
    display: inline-block !important;
    color: white !important;
  }
}
</style>
